import { getTranslatedText } from "@/features/internationalisation";
import { AdaptationType } from "@/types/adaptation";

export const buildAggregateSummaryXlsxFilename = ({
  schemaName,
  regionTypeSuffix = "",
  isLargeSite = false,
  adaptationType,
}: {
  schemaName: string;
  regionTypeSuffix?: string; // global/hk
  isLargeSite?: boolean;
  adaptationType?: AdaptationType;
}) => {
  // An absent adaptationType is a baseline download, so label it the same as an explicit "baseline"
  const resilienceSuffix =
    adaptationType && adaptationType !== "baseline"
      ? `_${getTranslatedText("terms:automatedResilience")}`
      : `_${getTranslatedText("terms:adaptationTypes.baseline")}`;
  const portfolioTypeSuffix = isLargeSite ? "Large Site Summary Results" : "Aggregate Summary Results";

  const basename = [schemaName, regionTypeSuffix, `${portfolioTypeSuffix}${resilienceSuffix}`]
    .filter(Boolean)
    .join(" - ");

  return `${basename}.xlsx`;
};
